import { useInfiniteTableItems } from "@/app/components/infinite-table/use-infinite-table-items"
import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"
import { CollectionMoleculeReatom } from "../store/index.reatom"

export const useActivityItemsReatom = () => {
  const { collectionActivityQueryParamsAtom } = useMolecule(
    CollectionMoleculeReatom,
  )
  const queryParams = collectionActivityQueryParamsAtom()
  const activityQuery = useSuspenseInfiniteQuery(queryParams)

  const queryResult = useMemo(
    () => ({
      ...activityQuery,
      pages: activityQuery.data.pages.map((page) => ({
        items: page.activities,
      })),
    }),
    [activityQuery],
  )

  return useInfiniteTableItems(queryResult)
}
